<template>
  <NewsletterPixel
    :title="title"
    :subtitle="subTitle"
    class="container unpadded"
    :sending="loading"
    :done="done"
    :subscription-result="subscriptionResult"
    @submitEmail="onSubmitEmail"
    @validationError="onValidationError"
  ></NewsletterPixel>
</template>
<script>
import { Newsletter as NewsletterPixel } from '@/pixel/index';
import useNewsletter from '@/compositions/useNewsletter.js';

import Tracking from '@/components/commons/Tracking.js';

export default {
  components: {
    NewsletterPixel,
  },
  props: {
    title: {
      type: String,
      default: `New products, sweet savings — straight to your inbox.`,
    },
    subTitle: String,
  },
  setup() {
    const {
      subscribeUserEmail, //
      subscriptionResult,
      loading,
      called,
      done,
    } = useNewsletter();

    return {
      subscribeUserEmail,
      subscriptionResult,
      loading,
      called,
      done,
    };
  },
  methods: {
    onValidationError() {
      this.done = false;
    },
    onSubmitEmail(email) {
      if (!this.called) {
        this.subscribeUserEmail({ email, subscriptionSource: 'Newsletter' });
        Tracking.heapIdentifyEmail(email);
      }
    },
  },
};
</script>
